import loadable from '@loadable/component'

export default [
  {
    path: '/CPPageV2',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-CPPageV2" */ '~/pages/CPRelationV2')
    ),
  },
  {
    path: '/CPRankV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRankV2" */ '~/pages/CPRelationV2/pages/Rank'
        )
    ),
  },
  {
    path: '/CPRuleV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRuleV2" */ '~/pages/CPRelationV2/pages/Rule'
        )
    ),
  },
  {
    path: '/CPNormalBannerV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPNormalBannerV2" */ '~/pages/CPRelationV2/pages/NormalBanner'
        )
    ),
  },
  {
    path: '/CPSpecialBannerV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPSpecialBannerV2" */ '~/pages/CPRelationV2/pages/SpecialBanner'
        )
    ),
  },
  {
    path: '/CPRoomModalV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRoomModalV2" */ '~/pages/CPRelationV2/pages/RoomModal'
        )
    ),
  },
]
